export const nav = [
    {
      text: "home",
      path: "/",
    },
    {
      text: "about",
      path: "/about",
    },
    {
      text: "services",
      path: "/services",
    },
    {
      text: "blog",
      path: "/blog",
    },
    {
      text: "pricing",
      path: "/pricing",
    },
    {
      text: "contact",
      path: "/contact",
    },
  ]
  export const featured = [
    {
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/hero/h1.png?raw=true",
      name: "Family House",
      total: "122 Property",
    },
    {
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/hero/h2.png?raw=true",
      name: "House & Villa",
      total: "155 Property",
    },
    {
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/hero/h3.png?raw=true",
      name: "Apartment",
      total: "300 Property",
    },
    {
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/hero/h4.png?raw=true",
      name: "Office & Studio",
      total: "80 Property",
    },
    {
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/hero/h6.png?raw=true",
      name: "Villa & Condo",
      total: "80 Property",
    },
  ]
  export const list = [
    {
      id: 1,
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/list/p-1.png?raw=true",
      name: "Red Carpet Real Estate",
      location: "210 Zirak Road, Canada",
      category: "For Rent",
      price: "$3,700",
      type: "Apartment",
    },
    {
      id: 2,
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/list/p-2.png?raw=true",
      name: "Fairmount Properties",
      location: "5698 Zirak Road, NewYork",
      category: "For Sale",
      price: "$9,750",
      type: "Condos",
    },
    {
      id: 3,
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/list/p-7.png?raw=true",
      name: "The Real Estate Corner",
      location: "5624 Mooker Market, USA",
      category: "For Rent",
      price: "$5,860",
      type: "Offices",
    },
    {
      id: 4,
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/list/p-4.png?raw=true",
      name: "Herringbone Realty",
      location: "5621 Liverpool, London",
      category: "For Sale",
      price: "$7,540",
      type: "Homes & Villas",
    },
    {
      id: 5,
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/list/p-5.png?raw=true",
      name: "Brick Lane Realty",
      location: "210 Montreal Road, Canada",
      category: "For Rent",
      price: "$4,850",
      type: "Commercial",
    },
    {
      id: 6,
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/list/p-6.png?raw=true",
      name: "Banyon Tree Realty",
      location: "210 Zirak Road, Canada",
      category: "For Sale",
      price: "$2,742",
      type: "Apartment",
    },
  ]
  export const awards = [
    {
      icon: <i class="fa-solid fa-trophy"></i>,
      num: "32 M	",
      name: "Blue Burmin Award",
    },
    {
      icon: <i class='fa-solid fa-briefcase'></i>,
      num: "43 M",
      name: "Mimo X11 Award",
    },
    {
      icon: <i class='fa-solid fa-lightbulb'></i>,
      num: "51 M",
      name: "Australian UGC Award",
    },
    {
      icon: <i class='fa-solid fa-heart'></i>,
      num: "42 M",
      name: "IITCA Green Award",
    },
  ]
  export const location = [
    {
      id: 1,
      name: "New Orleans, Louisiana",
      Villas: "12 Villas",
      Apartments: "10 Apartments",
      Offices: "07 Offices",
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/location/city-1.png?raw=true",
    },
    {
      id: 2,
      name: "Jerrsy, United State",
      Villas: "12 Villas",
      Apartments: "10 Apartments",
      Offices: "07 Offices",
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/location/city-2.png?raw=true",
    },
    {
      id: 3,
      name: "Liverpool, London",
      Villas: "12 Villas",
      Apartments: " 10 Apartments",
      Offices: "07 Offices",
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/location/city-3.png?raw=true",
    },
    {
      id: 4,
      name: "NewYork, United States",
      Villas: "12 Villas",
      Apartments: " 10 Apartments",
      Offices: "07 Offices",
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/location/city-4.png?raw=true",
    },
    {
      id: 5,
      name: "Montreal, Canada",
      Villas: "12 Villas",
      Apartments: " 10 Apartments",
      Offices: "07 Offices",
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/location/city-5.png?raw=true",
    },
    {
      id: 6,
      name: "California, USA",
      Villas: "12 Villas",
      Apartments: " 10 Apartments",
      Offices: "07 Offices",
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/location/city-6.png?raw=true",
    },
  ]
  export const team = [
    {
      list: "50",
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/customer/team-1.jpg?raw=true",
      address: "Liverpool, Canada",
      name: "Sargam S. Singh",
      icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
    },
    {
      list: "70",
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/customer/team-2.jpg?raw=true",
      address: "Montreal, Canada",
      name: "Harijeet M. Siller",
      icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
    },
    {
      list: "80",
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/customer/team-3.jpg?raw=true",
      address: "Denever, USA",
      name: "Anna K. Young",
      icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
    },
    {
      list: "51",
      cover: "https://github.com/sunil9813/Real-estate-website/blob/master/public/images/customer/team-4.jpg?raw=true",
      address: "2272 Briarwood Drive",
      name: "Michael P. Grimaldo",
      icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
    },
    {
      list: "42",
      cover: "https://images.pexels.com/photos/13677413/pexels-photo-13677413.jpeg?auto=compress&cs=tinysrgb&w=400&lazy=load",
      address: "2272 Briarwood Drive",
      name: "Michael P. Grimaldo",
      icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
    },
    {
      list: "38",
      cover: "https://images.pexels.com/photos/14535101/pexels-photo-14535101.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
      address: "Montreal, USA",
      name: "Adam K. Jollio",
      icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
    },
  ]
  export const price = [
    {
      plan: "Basic",
      price: "29",
      ptext: "per user, per month",
      list: [
        {
          icon: '✔',
          text: "99.5% Uptime Guarantee",
        },
        {
          icon: '✔',
          text: "120GB CDN Bandwidth",
        },
        {
          icon: '✔',
          text: "5GB Cloud Storage",
        },
        { change: "color", icon: '✘', text: "Personal Help Support" },
        { change: "color", icon: '✘', text: "Enterprise SLA" },
      ],
    },
    {
      best: "Best Value",
      plan: "Standard",
      price: "49",
      ptext: "per user, per month",
      list: [
        {
          icon: '✔',
          text: "99.5% Uptime Guarantee",
        },
        {
          icon: '✔',
          text: "150GB CDN Bandwidth",
        },
        {
          icon: '✔',
          text: "10GB Cloud Storage",
        },
        {
          icon: '✔',
          text: "Personal Help Support",
        },
        {
          change: "color",
          icon: '✘',
          text: "Enterprise SLA",
        },
      ],
    },
    {
      plan: "Platinum",
      price: "79",
      ptext: "2 user, per month",
      list: [
        {
          icon: '✔',
          text: "100% Uptime Guarantee",
        },
        {
          icon: '✔',
          text: "200GB CDN Bandwidth",
        },
        {
          icon: '✔',
          text: "20GB Cloud Storage",
        },
        {
          icon: '✔',
          text: "Personal Help Support",
        },
        {
          icon: '✔',
          text: "Enterprise SLA",
        },
      ],
    },
  ]
  export const footer = [
    {
      title: "LAYOUTS",
      text: [{ list: "Home Page" }, { list: "About Page" }, { list: "Service Page" }, { list: "Property Page" }, { list: "Contact Page" }, { list: "Single Blog" }],
    },
    {
      title: "ALL SECTIONS",
      text: [{ list: "Headers" }, { list: "Features" }, { list: "Attractive" }, { list: "Testimonials" }, { list: "Videos" }, { list: "Footers" }],
    },
    {
      title: "COMPANY",
      text: [{ list: "About" }, { list: "Blog" }, { list: "Pricing" }, { list: "Affiliate" }, { list: "Login" }, { list: "Changelog" }],
    },
  ]